import styled from "styled-components";

export const CashbackCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 20px 24px;
  margin-top: 80px;
  max-width: 520px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 4px;
  }

  .infoIcon {
    font-size: 18px;
    color: #777;
    cursor: pointer;

    &:hover {
      color: #000;
    }
  }

  .subtext {
    font-size: 13px;
    color: #777;
  }
`;